'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseComponent = require('base-component');

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _mobxReact = require('mobx-react');

var _autoclassDecorator = require('autoclass-decorator');

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmationModal = (0, _mobxReact.observer)(_class = (0, _autoclassDecorator2.default)(_class = function (_BaseComponent) {
    (0, _inherits3.default)(ConfirmationModal, _BaseComponent);

    function ConfirmationModal() {
        (0, _classCallCheck3.default)(this, ConfirmationModal);
        return (0, _possibleConstructorReturn3.default)(this, (ConfirmationModal.__proto__ || (0, _getPrototypeOf2.default)(ConfirmationModal)).apply(this, arguments));
    }

    (0, _createClass3.default)(ConfirmationModal, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var Component = this.viewStore.Component;

            return _react2.default.createElement(
                'div',
                { className: this.viewStore.showConfirmationModal === true ? "confirmation-modal" : "confirmation-modal hidden" },
                !!Component ? _react2.default.createElement(
                    'div',
                    { className: 'box' },
                    _react2.default.createElement(Component, null)
                ) : _react2.default.createElement(
                    'div',
                    { className: 'box' },
                    this.viewStore.setTitle() !== false && _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        this.viewStore.setTitle()
                    ),
                    this.viewStore.setMessage() !== false && _react2.default.createElement(
                        'div',
                        { className: 'message' },
                        this.viewStore.setMessage()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'actions' },
                        this.viewStore.setCancelLabel() !== false && _react2.default.createElement(
                            'div',
                            { className: "btn" + this.viewStore.setCancelBtnClass(), onClick: function onClick(event) {
                                    return _this2.viewStore.onCancel(event);
                                } },
                            this.viewStore.setCancelLabel()
                        ),
                        this.viewStore.setConfirmLabel() !== false && _react2.default.createElement(
                            'div',
                            { className: "btn" + this.viewStore.setConfirmBtnClass(), onClick: function onClick(event) {
                                    return _this2.viewStore.onConfirm(event);
                                } },
                            this.viewStore.setConfirmLabel()
                        )
                    )
                )
            );
        }
    }]);
    return ConfirmationModal;
}(_baseComponent2.default)) || _class) || _class;

;

var _default = ConfirmationModal;
exports.default = _default;
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(ConfirmationModal, 'ConfirmationModal', 'src/core_modules/confirmation-modal/index.jsx');

    __REACT_HOT_LOADER__.register(_default, 'default', 'src/core_modules/confirmation-modal/index.jsx');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/confirmation-modal/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/confirmation-modal/index.js
// module chunks = 0